const ADVISORY_CUSTOM_ELEMENT = 'advisory-web';
const ADVISORY_RECOMMENDATION_CUSTOM_ELEMENT = 'advisory-recommendation';

export default {
  ADVISORY_CUSTOM_ELEMENT,
  ADVISORY_RECEIVED_DATA_SCRIPT_ID: `${ADVISORY_CUSTOM_ELEMENT}:received-data`,
  ADVISORY_ACTION_EVENT: `${ADVISORY_CUSTOM_ELEMENT}:action`,
  ADVISORY_CUSTOM_ELEMENT_LOADED_EVENT: `${ADVISORY_CUSTOM_ELEMENT}:item-loaded`,
  ADVISORY_RECOMMENDATION_CUSTOM_ELEMENT,
  ADVISORY_RECOMMENDATION_CUSTOM_ELEMENT_LOADED_EVENT: `${ADVISORY_RECOMMENDATION_CUSTOM_ELEMENT}:item-loaded`
};
